// Reviewer assignments store employee names, so keep option values as names.
export const getReviewerNames = (employees, designation) =>
  [...new Set(employees
    .filter((employee) => (Array.isArray(designation) ? designation : [designation])
      .some((value) => employee.designation?.trim().toLowerCase() === value.toLowerCase()))
    .map((employee) => employee.fullName?.trim())
    .filter(Boolean))]
    .sort((a, b) => a.localeCompare(b));
